<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <node-broker-creator
          ref="node_broker_creator"
          :create_node_broker="create_node_broker"
          :create_first="true"
          @node_brokers="set_node_brokers"
          @new_broker="new_broker"
        ></node-broker-creator>
      </v-col>
    </v-row>
    <v-row v-if="!create_node_broker && node_brokers">
      <v-col cols="12" sm="6"
        ><node-broker-selector
          @accounts_selected="set_accounts_selected"
        ></node-broker-selector>
      </v-col>
      <v-col cols="12" v-show="broker_conns?.length > 0">
        <tradovate-broker-connector
          ref="tradovate_br_conn"
          @set_users_data="set_users_data"
        ></tradovate-broker-connector>
      </v-col>
    </v-row>
    <v-row v-if="!create_node_broker && node_brokers"
      ><v-col cols="12" v-show="broker_conns?.length > 0">
        <tradovate-accounts-data
          :users_data="users_data"
        ></tradovate-accounts-data>
      </v-col>
    </v-row>
    <dash-automations></dash-automations>
  </v-container>
</template>

<script>
import NodeBrokerCreator from "@/components/nodeBrokers/NodeBrokerCreatorV2.vue";
import TradovateShowConnected from "@/components/nodeBrokers/TradovateShowConnected.vue";
import NodeBrokerSelector from "@/components/nodeBrokers/NodeBrokerSelector.vue";
import TradovateBrokerConnector from "@/components/terminal/TradovateBrokerConnector.vue";
import TradovateAccountsData from "@/components/dashboard/TradovateAccountsData.vue";
import DashAutomations from "@/components/dashboard/DashAutomations.vue";

export default {
  name: "Dashboard",
  components: {
    NodeBrokerCreator,
    NodeBrokerSelector,
    TradovateBrokerConnector,
    TradovateAccountsData,
    DashAutomations,
  },
  mixins: [TradovateShowConnected],

  data() {
    return {
      broker_conns: null,
      node_brokers: null,
      create_node_broker: false,
      users_data: [],
      mock: false,
      debug: false,
    };
  },
  methods: {
    set_users_data(users_data) {
      if (this.debug) console.log("users_data", users_data?.length, users_data);
      this.users_data = users_data;
    },
    set_accounts_selected(accounts_selected) {
      let brokers_m = new Map();
      accounts_selected?.forEach((acc) => {
        let b = brokers_m.get(acc.broker.id);
        if (!b) {
          b = { broker: acc.broker, account_ids: [] };
          brokers_m.set(acc.broker.id, b);
        }
        b.account_ids.push(acc.account.id);
      });
      this.broker_conns = Array.from(brokers_m.values());
      this.$refs?.tradovate_br_conn?.swap_conn(this.broker_conns);
    },
    set_node_brokers(node_brokers) {
      this.node_brokers = node_brokers;
    },
    new_broker() {
      this.$refs?.node_broker_creator?.fetch_node_brokers();
      this.create_node_broker = false;
      let res = this.T.remove_from_router(
        this.router?.query,
        "create_node_broker"
      );
      if (res.mod) this.$router.replace({ query: res.query });
    },
    set_create_node_broker(val) {
      if (val) this.create_node_broker = true;
      else this.create_node_broker = false;
    },
  },
  computed: {},

  mounted() {
    this.$watch(
      () => {
        return this.$route?.query?.create_node_broker;
      },
      (nval) => {
        this.set_create_node_broker(nval);
      }
    );
    this.set_create_node_broker(this.$route?.query?.create_node_broker);
  },
};
</script>
